// src/reducers/taxSettingsReducer.js
import {
  GET_TAX_SETTINGS,
  GET_ACCOUNT_TAX_SETTINGS,
  UPDATE_DEFAULT_TAX_RATE,
  TOGGLE_TAXABLE,
  UPDATE_TAX_RATE,
  APPLY_DEFAULT_RATE_TO_ALL,
  SAVE_TAX_SETTINGS_SUCCESS,
  TOGGLE_ACCOUNT_TAXABLE,
  UPDATE_ACCOUNT_TAX_RATE,
} from '../../actions/actionTypes';

const initialState = {
  companyTaxConfig: {
    defaultTaxRate: 0
  },
  chargeTaxSettings: [],
  accountTaxSettings: []
};

export default function taxSettingsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_TAX_SETTINGS:
      return {
        ...state,
        companyTaxConfig: action.payload.companyTaxConfig,
        chargeTaxSettings: action.payload.chargeTaxSettings
      };
      
    case GET_ACCOUNT_TAX_SETTINGS:
      return {
        ...state,
        accountTaxSettings: action.payload.accountTaxSettings
      };
      
    case UPDATE_DEFAULT_TAX_RATE:
      return {
        ...state,
        companyTaxConfig: {
          ...state.companyTaxConfig,
          defaultTaxRate: action.payload
        }
      };
      
    case TOGGLE_ACCOUNT_TAXABLE:
      return {
        ...state,
        accountTaxSettings: state.accountTaxSettings.map(charge => 
          charge.chargeListId === action.payload
            ? { 
                ...charge, 
                isTaxable: !charge.isTaxable,
                taxRate: !charge.isTaxable ? state.companyTaxConfig.defaultTaxRate : 0
              }
            : charge
        )
      };
  
    case UPDATE_ACCOUNT_TAX_RATE:
      return {
        ...state,
        accountTaxSettings: state.accountTaxSettings.map(charge => 
          charge.chargeListId === action.payload.chargeListId
            ? { ...charge, taxRate: action.payload.rate }
            : charge
        )
      };
      
    case TOGGLE_TAXABLE:
      // This should always update the company's chargeTaxSettings
      return {
        ...state,
        chargeTaxSettings: state.chargeTaxSettings.map(charge => 
          charge.chargeListId === action.payload
            ? { 
                ...charge, 
                isTaxable: !charge.isTaxable,
                taxRate: !charge.isTaxable ? state.companyTaxConfig.defaultTaxRate : 0
              }
            : charge
        )
      };
  
    case UPDATE_TAX_RATE:
      // This should always update the company's chargeTaxSettings
      return {
        ...state,
        chargeTaxSettings: state.chargeTaxSettings.map(charge => 
          charge.chargeListId === action.payload.chargeListId
            ? { ...charge, taxRate: action.payload.rate }
            : charge
        )
      };
  
    case APPLY_DEFAULT_RATE_TO_ALL:
      return {
        ...state,
        chargeTaxSettings: state.chargeTaxSettings.map(charge => ({
          ...charge,
          // Mark all charges as taxable and apply the default rate
          isTaxable: true,
          taxRate: state.companyTaxConfig.defaultTaxRate
        }))
      };
  
    case SAVE_TAX_SETTINGS_SUCCESS:
      return {
        ...state,
        companyTaxConfig: action.payload.companyTaxConfig,
        chargeTaxSettings: action.payload.chargeTaxSettings
      };
      
    default:
      return state;
  }
}